<template>
  <aside class="app-sidebar">
    <div class="app-sidebar__user text-center">
      <img
        v-if="account"
        class="mb-3"
        :src="`data:image/png;base64,${account.image}`"
        alt="User Image"
        width="100"
      />
      <img
        v-else
        class="mb-3"
        src="@/assets/user.png"
        alt="User Image"
        width="120"
      />
      <div v-if="isAuthenticated">
        <p class="app-sidebar__user-name">{{ user.name }}</p>
        <p class="app-sidebar__user-designation">{{ account.job_position }}</p>
        <p class="app-sidebar__user-designation">
          <span v-if="account.department">{{ account.department.name }}</span>
        </p>
      </div>
    </div>
    <ul class="app-menu">
      <li>
        <router-link :to="{ name: 'dashboard' }" class="app-menu__item">
          <i class="bi bi-speedometer app-menu__icon"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link :to="{ name: 'doctor' }" class="app-menu__item">
          <i class="bi bi-person-lines-fill app-menu__icon"></i>
          <span class="app-menu__label">Doctor [HOSxP]</span>
        </router-link>
      </li> -->

      <!-- <li>
        <router-link :to="{ name: 'building' }" class="app-menu__item">
          <i class="bi bi-building app-menu__icon"></i>
          <span class="app-menu__label">สิ่งก่อสร้าง</span>
        </router-link>
      </li> -->
      <div v-if="user && user.role == 'admin'">
        <li>
          <router-link :to="{ name: 'leavework' }" class="app-menu__item">
            <i class="bi bi-envelope-paper-fill app-menu__icon"></i>
            <span class="app-menu__label">บันทึกการลา</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'doctor' }" class="app-menu__item">
            <i class="bi bi-person-lines-fill app-menu__icon"></i>
            <span class="app-menu__label">รายชื่อแพทย์</span>
          </router-link>
        </li>
        <!-- <li>
          <router-link :to="{ name: 'leavetypes' }" class="app-menu__item">
            <i class="bi bi-list-ol app-menu__icon"></i>
            <span class="app-menu__label">ประเภทการลา</span>
          </router-link>
        </li> -->
      </div>
    </ul>
  </aside>
</template>


<script>
import usersService from "@/services/users-service";
import { mapState } from "vuex";
export default {
  data() {
    return {
      account: {},
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    async getUser(id) {
      try {
        const res = await usersService.get(id);
        this.account = res.data.account;
      } catch (error) {
        this.showError(error);
        localStorage.removeItem("vuex");
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    ...mapState(["app", "user"]),
  },
  created() {
    this.getUser(this.user.id);
  },
};
</script>


<style scoped>
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}
</style>